<template>
  <div class="max-w-6xl mx-auto py-6 px-3 sm:px-6 lg:px-8">
    <div class="flex flex-col">
      <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <enrolment-list />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import EnrolmentList from '@/components/enrolment/list/EnrolmentList.vue'

export default defineComponent({
  components: { EnrolmentList },
})
</script>

<style scoped></style>
